(() => {
  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach(wrap => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('[data-step]').forEach(btn => {
      btn.addEventListener('click', () => {
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.step, 10));
        input.value = next;
      });
    });
  });

  // Variant select: update price, availability and URL
  document.querySelectorAll('[data-buy]').forEach(buy => {
    const select = buy.querySelector('[data-variant-select]');
    if (!select) return;
    const priceEl = buy.querySelector('[data-price]');
    const compareEl = buy.querySelector('[data-compare]');
    const addBtn = buy.querySelector('[data-add]');
    const sticky = document.querySelector('[data-sticky-price]');
    select.addEventListener('change', () => {
      const opt = select.selectedOptions[0];
      priceEl.textContent = opt.dataset.price;
      if (sticky && buy.closest('[data-main-buy]')) sticky.textContent = opt.dataset.price;
      if (opt.dataset.compare) { compareEl.textContent = opt.dataset.compare; compareEl.hidden = false; }
      else { compareEl.textContent = ''; compareEl.hidden = true; }
      const available = opt.dataset.available === 'true';
      addBtn.disabled = !available;
      addBtn.textContent = available ? 'Add to cart' : 'Sold out';
      if (buy.closest('[data-main-buy]')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', select.value);
        history.replaceState({}, '', url);
      }
    });
  });

  // Product gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(g => {
    const slides = g.querySelectorAll('[data-slide]');
    const thumbs = g.querySelectorAll('[data-thumb]');
    thumbs.forEach(t => t.addEventListener('click', () => {
      slides.forEach(s => { s.hidden = s.dataset.slide !== t.dataset.thumb; });
      thumbs.forEach(x => x.removeAttribute('aria-current'));
      t.setAttribute('aria-current', 'true');
    }));
  });

  // Sticky add to cart on mobile when main button is off screen
  const sticky = document.querySelector('[data-sticky-buy]');
  const mainBuy = document.querySelector('[data-main-buy] .buy__row');
  if (sticky && mainBuy && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }).observe(mainBuy);
  }

  // Close mobile menu on link click
  document.querySelectorAll('[data-menu] a').forEach(a => a.addEventListener('click', () => a.closest('details').removeAttribute('open')));

  // AJAX add to cart: on success go straight to the cart (fewer steps to checkout); errors show a toast
  const toast = document.querySelector('[data-toast]');
  const toastMsg = toast && toast.querySelector('[data-toast-msg]');
  let toastTimer;
  const showToast = (msg, isError) => {
    if (!toast) return;
    toastMsg.textContent = msg;
    toast.classList.toggle('is-error', !!isError);
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 4000);
  };
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form || !window.fetch || !window.routes) return;
    e.preventDefault();
    const buttons = document.querySelectorAll(`[name="add"][form="${form.id}"], form[data-ajax-cart]#${CSS.escape(form.id || 'x')} [name="add"]`);
    const own = form.querySelectorAll('[name="add"]');
    const all = [...new Set([...buttons, ...own])];
    all.forEach(b => b.setAttribute('aria-busy', 'true'));
    try {
      const res = await fetch(window.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok) { showToast(data.description || data.message || 'Could not add to cart.', true); return; }
      window.location.href = window.routes.cart;
    } catch (err) {
      form.removeAttribute('data-ajax-cart');
      form.submit();
    } finally {
      all.forEach(b => b.removeAttribute('aria-busy'));
    }
  });

  // Collection: auto-submit filters and sort
  document.querySelectorAll('[data-facets]').forEach(form => {
    form.addEventListener('change', e => {
      if (e.target.type === 'number') return;
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
    form.addEventListener('submit', () => {
      // drop empty fields for clean URLs
      form.querySelectorAll('input[type=number]').forEach(i => { if (i.value === '') i.disabled = true; });
    });
  });

  // Body map: highlight zone while hovering or focusing an area link
  document.querySelectorAll('[data-areas]').forEach(sec => {
    const set = (zone, on) => sec.querySelectorAll(`.zone[data-zone="${zone}"]`).forEach(z => z.classList.toggle('is-active', on));
    sec.querySelectorAll('[data-zone-link]').forEach(link => {
      const z = link.dataset.zoneLink;
      ['mouseenter', 'focus'].forEach(ev => link.addEventListener(ev, () => set(z, true)));
      ['mouseleave', 'blur'].forEach(ev => link.addEventListener(ev, () => set(z, false)));
    });
    sec.querySelectorAll('.zone').forEach(zone => {
      const z = zone.dataset.zone;
      zone.addEventListener('mouseenter', () => sec.querySelector(`[data-zone-link="${z}"]`)?.classList.add('is-active'));
      zone.addEventListener('mouseleave', () => sec.querySelector(`[data-zone-link="${z}"]`)?.classList.remove('is-active'));
    });
  });

  // Product recommendations (loaded after page render)
  document.querySelectorAll('[data-recs]').forEach(async el => {
    if (el.children.length) return;
    try {
      const html = await (await fetch(el.dataset.url)).text();
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (e) {}
  });
})();
